<template>
    <div>
        <div class="fix-bottom" >
            <div class="fix-left js-roomDetailBtn">
                <span class="price">{{totalPrice}}</span>美元(上船自动房卡扣款)&nbsp;|&nbsp;<span class="my" @click="isShowShorexBookingDetail=true">明细&nbsp;<span class="gt">&gt;</span></span>
            </div>
            <div class="btn-shorex order-btn" @click="submitShorex()">升级精品游</div>
        </div>

        <div class="popup orderDetail-box js-smartScroll" :class="{ 'modal-in': isShowShorexBookingDetail, 'modal-out': !isShowShorexBookingDetail}" 
            id="shorexBookingDetail" v-show="isShowShorexBookingDetail">
            <div class="popup-bg" @click="isShowShorexBookingDetail=false"></div>
            <div class="popupover-m orderDetail slideInUp">
                <div class="popupover-close js-orderDetailClose slideInUp" @click="isShowShorexBookingDetail=false">
                    <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon17.png" class="">
                </div>
                <div class="popupover-title">
                    <div class="popupover-title-m">
                        <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon16.png">
                        费用明细
                    </div>
                </div>

                <div class="d-list" id="shorexPriceDetail">
                    <div class="d-list-item" v-for="(selectedShorex) in selectedShorexes" :key="selectedShorex.shorex.shorexId">
                        <div class="l-item">
                            <p class="l-title">{{selectedShorex.shorex.shorexName}}</p>
                            <div class="sub-item" v-for="(booking) in selectedShorex.bookings" :key="booking.bookingId">
                                <div class="d-order">
                                    <div class="d-notice"><span class="d-line"
                                            style="display:inline-block;position: relative;top: 2px;"></span><span
                                            class="d-txt">订单号：{{booking.bookingId}}</span></div>
                                    <div class="per-price">{{selectedShorex.shorex.price}}美元/人</div>
                                </div>
                                <p>{{getCruise(booking).cruiseName}}</p>
                                <p>{{getCruise(booking).cruiseNightDate}} {{getCruise(booking).shipName}}</p>
                                <p>{{getCruise(booking).sailDateBegin}} - {{getCruise(booking).sailDateEnd}}</p>
                                <p>乘客信息：{{getGuestName(booking)}}</p>
                            </div>
                            <div class="l-total"> 合计 <span style="color:#FF5055;">&nbsp;{{getBookingPrice(selectedShorex)}} &nbsp;</span> 美元</div>
                        </div>
                        <div class="d-list-item-line"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "PaySuccessShorexBottom",
    props: {
        selectedShorexes: {
            type: Array
        },
        shorexes: {
            type: Array
        }
    },
    data () {
        return {
            isShowShorexBookingDetail: false
        }
    },
    methods: {
        getGuests (booking) {
            return booking.bookingGuests || []
        },
        getGuestName (booking) {
            let guestName = []
            const guests = this.getGuests(booking)
            guests.forEach((guest) => {
                let name = guest.chineseLastName + guest.chineseFirstName
                if (!name || name.length == 0) {
                    name = `${guest.pinYinLastName} ${guest.pinYinFirstName}`
                }
                guestName.push(name)
            })
            return guestName.join(' | ')
        },
        getCruise (booking) {
            return booking.cruise || {}
        },
        getBookingPrice (selectedShorex) {
            if (selectedShorex.shorex && selectedShorex.bookings) {
                let amount = 0
                selectedShorex.bookings.forEach((booking) => {
                    amount += selectedShorex.shorex.price * this.getGuests(booking).length
                })
                return amount
            }
            return 0
        },
        async submitShorex () {
            let submitShorex = []
            this.selectedShorexes.forEach((selectedShorex) => {
                if (selectedShorex.shorex && selectedShorex.bookings) {
                    selectedShorex.bookings.forEach((booking) => {
                        submitShorex.push({
                            bookingId: booking.bookingId,
                            shorexId: selectedShorex.shorex.id
                        })
                    })
                }
            })
            if (submitShorex.length == 0) {
                this.$alert.show('请选择升级的岸上观光')
                return
            }
            const requestData = {
                viewModel: submitShorex
            }
            this.$loading.show()
            const { success, errMsg } = await api.booking.selectShorex(requestData)
            this.$loading.hide()
            if (success) {
                this.$alert.show('升级成功', {
                    confirmCallBack: ()=> {
                        this.$router.push({
                            name: "BookingList"
                        })
                    }
                })
                return 
            }else{
                if (errMsg && errMsg.length > 0) {
                    this.$alert.show(errMsg)
                }
            }

            console.error(errMsg)
        }
    },
    computed: {
        totalPrice () {
            let amount = 0
            this.selectedShorexes.forEach((selectedShorex) => {
                amount += this.getBookingPrice(selectedShorex)
            })
            return amount
        }
    }
}
</script>

<style lang="less" scoped>
p {
    margin: 0;
}
.fix-bottom {
    display: flex;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    height: 50px;
    .fix-left {
        background: #4A90E2;
        height: 50px;
        width: 253px;
        color: #fff;
        font-size: 12px;
        line-height: 50px;
        padding-left: 20px;
        .price {
            font-size: 14px;
            font-weight: bold;
        }
        .my {
            font-size: 14px;
        }
        .gt {
            display: inline-block;
            color: #fff;
            font-size: 14px;
            transform: rotate(-90deg) scaleY(1.5);
            -webkit-transform: rotate(-90deg) scaleY(1.5);
            -moz-transform: rotate(-90deg) scaleY(1.5);
            -ms-transform: rotate(-90deg) scaleY(1.5);
            -o-transform: rotate(-90deg) scaleY(1.5);
        }
    }

    .btn-shorex {
        background: #FEBC10;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #333;
        width: 122px;
        font-size: 14px;
    }
}

#shorexBookingDetail {
    position: fixed;
    background-color: transparent;
    -webkit-transform: translate3d(0, 100%, 0);
    -moz-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
    .popup-bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.4);
        position: fixed;
        bottom: 0;
        left: 0;
    }
    .popupover-m {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        max-height: 70%;
        overflow: scroll;
        background-color: #F6F7F8;
        border-top: 5px solid #FEBC10;
        .popupover-close {
            position: absolute;
            right: 0;
            top: -1px;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            width: 30px;
            height: 30px;
            background-color: #FEBC10;
            border-bottom-left-radius: 5px;
            img {
                width: 17px;
            }
        }
        .popupover-title {
            padding: 25px 20px 5px;
            background-color: #fff;
            .popupover-title-m {
                font-size: 14px;
                color: #4A90E2;
                letter-spacing: 0;
                padding-bottom: 5px;
                img {
                    max-height: 16px;
                }
            }
        }
        .d-list {
            height: 91%;
            overflow: scroll;
            border-top: 1px solid #E5E5E5;
            .d-list-item {
                background: #fff;
                padding-bottom: 10px;
                width: 100%;
                position: relative;
                .l-item {
                    padding: 15px 20px 0;
                    padding-bottom: 10px;
                    .l-title {
                        font-size: 14px;
                        color: #333;
                        background: #fff;
                    }
                    .sub-item {
                        font-size: 12px;
                        border-bottom: 1px dashed #E5E5E5;
                        background: #fff;
                        padding-bottom: 12px;
                        p {
                            margin-bottom: 9px;
                            margin-left: 5px;
                            color: #333333;
                        }
                    }
                    .d-order {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 9px;
                        .d-line {
                            -webkit-box-flex: 0;
                            -webkit-flex: none;
                            -moz-box-flex: 0;
                            -ms-flex: none;
                            flex: none;
                            width: 3px;
                            height: 14px;
                            margin-right: 5px;
                            background-color: #4A90E2;
                            border-radius: 1px;
                            display: inline-block;
                            position: relative;
                            top: 2px;
                        }
                        .d-txt {
                            -webkit-box-flex: 1;
                            -webkit-flex: 1;
                            -moz-box-flex: 1;
                            -ms-flex: 1;
                            flex: 1;
                            line-height: 20px;
                            color: #4A90E2;
                        }
                    }
                    .d-order:first-child {
                        padding-top: 15px;
                    }
                    .l-total {
                        text-align: right;
                        font-size: 14px;
                        color: #333;
                        margin-top: 18px;
                        margin-bottom: 8px;
                        font-weight: bold;
                    }
                }
                .d-list-item-line {
                    position: absolute;
                    left: -20px;
                    bottom: 0;
                    width: 375px;
                    height: 10px;
                    background: #f6f7f8;
                }
            }
        }
    }
    
}

#shorexBookingDetail.modal-in {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    display: block;
}

#shorexBookingDetail.modal-out {
    -webkit-transform: translate3d(0, 100%, 0);
    -moz-transform:translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
}
</style>